import type { ReactElement } from 'react';
import { styled } from 'styled-components';

interface Props {
  header: ReactElement;
  content: ReactElement;
}

const Container = styled.div`
  height: 100vh;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-areas:
    'header'
    'content';
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
`;

const HeaderArea = styled.div`
  grid-area: header;
`;

const ContentArea = styled.div`
  grid-area: content;
`;

export const Layout = ({ header, content }: Props) => {
  return (
    <Container>
      <HeaderArea>{header}</HeaderArea>
      <ContentArea>{content}</ContentArea>
    </Container>
  );
};
